// src/utils/errorLogger.js
const ERROR_QUEUE_KEY = 'offline_error_queue'
const ERROR_HISTORY_KEY = 'recent_errors' // สำหรับดักการส่งซ้ำ (ใช้ Session Storage)
const MAX_PAYLOAD_SIZE = 100000 // ลิมิตขนาดข้อมูลที่ประมาณ 100KB
const SPAM_DELAY_MS = 300000 // 5 นาที (300,000 ms) ป้องกันการส่ง Error หน้าตาเดิมรัวๆ
const DISCORD_WEBHOOK_URL = 'https://discord.com/api/webhooks/1485657628142076045/_M0n8U5MDhau9Wxlk_q13YR_aQKD1vAkB7V74S2JPlLlwop8azyOeHBfptYiVMg4H4tB' // 🔹 วางลิงก์ Webhook ที่แจกจาก Discord ที่นี่

// --- ฟังก์ชันช่วยเหลือ (Helpers) สำหรับความปลอดภัย ---

// ระบบเซนเซอร์ข้อมูลส่วนบุคคลถูกนำออกตามคำขอ (แสดงข้อมูลดิบทั้งหมด)

// 2. ระบบป้องกันการส่งซ้ำรัวๆ (Throttle / Debounce)
const isSpamming = (errorMsg) => {
  try {
    const history = JSON.parse(sessionStorage.getItem(ERROR_HISTORY_KEY) || '{}')
    const now = Date.now()

    // ล้างประวัติที่เก่ากว่าเวลาที่ตั้งไว้ทิ้ง
    for (let key in history) {
      if (now - history[key] > SPAM_DELAY_MS) {
        delete history[key]
      }
    }

    const shortMsg = String(errorMsg).substring(0, 50) // ใช้ข้อความย่อ 50 ตัวอักษรเพื่อตรวจสอบ
    if (history[shortMsg]) {
      sessionStorage.setItem(ERROR_HISTORY_KEY, JSON.stringify(history))
      return true // ตรวจพบว่าเป็นการส่งซ้ำ
    }

    history[shortMsg] = now
    sessionStorage.setItem(ERROR_HISTORY_KEY, JSON.stringify(history))
    return false
  } catch (e) { return false }
}

// 3. ตัวตรวจจับข้อจำกัดขนาดของ Payload (ป้องกัน Localstorage แตกบึ้ม)
const isTooLarge = (payloadStr) => {
  return typeof payloadStr === 'string' && payloadStr.length > MAX_PAYLOAD_SIZE
}

// 4. แปลข้อความ Error แบบสั้นๆ และบอกหน้าเว็บที่เกิดปัญหา
const translateErrorForNonDev = (errorMsg, source, fullUrl) => {
  const msg = String(errorMsg).toLowerCase()

  // พยายามดึงชื่อหน้า (path) และ query string จาก url
  let pathName = '-'
  try {
    const parsedUrl = new URL(fullUrl)
    pathName = String(parsedUrl.pathname + parsedUrl.search)
      .replace(/`/g, "'") // 🛡️ กัน backtick พังในกล่องโค้ด Discord
      .substring(0, 300) // 🛡️ กัน String ยาวเกินไปจนบอท Error
  } catch (e) {}

  let issueType = 'ไม่ทราบสาเหตุ'

  if (msg.includes('network error') || msg.includes('cors')) {
    issueType = 'ข้อผิดพลาดด้านการเชื่อมต่ออินเทอร์เน็ต (Network)'
  } else if (msg.includes('500') || msg.includes('internal server')) {
    issueType = 'ข้อผิดพลาดที่เซิร์ฟเวอร์ (API Server Down)'
  } else if (msg.includes('400') || msg.includes('401') || msg.includes('403') || msg.includes('404') || msg.includes('422')) {
    issueType = 'ข้อผิดพลาดเกี่ยวกับข้อมูลที่ส่งไป API (API Reject)'
  } else if (String(source).includes('Vue') || String(source).includes('Promise')) {
    issueType = 'ข้อผิดพลาดที่ระบบแสดงผล (Frontend Bug)'
  }

  return `พบปัญหา: ${issueType}\nที่หน้าเว็บ: ${pathName}`
}

// --- ฟังก์ชันหลักในการทำงาน (Core Logger) ---

// ยิงเตือนเข้า Discord แบบเรียลไทม์ (ใช้ fetch พื้นฐานแทน axios เพื่อไม่ให้วนอ่างกลับเข้า Logger ถ้ายิงพัง)
const sendToDiscord = async (errorData) => {
  if (!DISCORD_WEBHOOK_URL || !navigator.onLine) return false

  try {
    const payload = {
      username: '🚨 Betask Web Error',
      embeds: [{
        title: '🔥 New System Error',
        color: 16711680, // สีแดง (Hex to Decimal)
        description: `**📝 สรุปสาเหตุเบื้องต้น:**\n\`\`\`fix\n${translateErrorForNonDev(errorData.message, errorData.source, errorData.url)}\n\`\`\`\n**🤖 ข้อความจากระบบ (Dev):**\n\`\`\`text\n${String(errorData.message).replace(/`/g, "'").substring(0, 500)}\n\`\`\``,
        fields: [
          { name: '📍 Source', value: String(errorData.source || '-').substring(0, 100), inline: true },
          { name: '🏪 Shop ID', value: String(errorData.shopId || '-').substring(0, 100), inline: true },
          { name: '🔗 URL', value: String(errorData.url).substring(0, 200) }
        ],
        footer: { text: `Time (Client): ${new Date(errorData.timestamp).toLocaleString('th-TH', { timeZone: 'Asia/Bangkok' })}` }
      }]
    }

    // แปะ Request Data (เช่น Payload ของ Axios ขาไป และ ขากลับ) ลงในกล่อง Embed
    if (errorData.requestContext) {
      payload.embeds[0].fields.push({
        name: '📦 API Request & Response Body',
        value: `\`\`\`json\n${String(errorData.requestContext).replace(/`/g, "'").substring(0, 1000)}\n\`\`\``,
        inline: false
      })
    }

    // สร้างตัวจับเวลา ป้องกันกรณีจำลอง Offline ขัดข้องแล้ว Discord ค้างรอไม่ยอมตอบ
    let timerId
    const timeoutPromise = new Promise((resolve, reject) => {
      timerId = setTimeout(() => reject(new Error('Discord Timeout (5s)')), 5000)
    })

    const reqPromise = fetch(DISCORD_WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })

    const res = await Promise.race([reqPromise, timeoutPromise])
    clearTimeout(timerId) // เคลียร์ตัวจับเวลาทิ้งในกรณีที่ยิงสำเร็จก่อน 5 วินาที

    if (!res.ok) {
      console.error('Discord Webhook ตอบหลับมาว่าพัง (Status):', res.status, await res.text())
      return false
    }
    return true
  } catch (e) {
    console.warn('ไม่สามารถยิง Discord ได้ ลัดคิวเข้า Local Storage ก่อน:', e.message || e)
    return false
  }
}

// บันทึกใส่ระบบเมื่อไม่มีอินเทอร์เน็ต (Offline Queue)
const saveToOfflineQueue = (errorData) => {
  try {
    const queue = JSON.parse(localStorage.getItem(ERROR_QUEUE_KEY) || '[]')
    // เก็บสูงสุด 50 error ล่าสุดเท่านั้น พอเกินให้เด้งทิ้ง
    if (queue.length < 50) {
      queue.push(errorData)
      localStorage.setItem(ERROR_QUEUE_KEY, JSON.stringify(queue))
    }
  } catch (e) {
    console.error('ไม่สามารถบันทึก error ลงแบบออฟไลน์ได้', e)
  }
}

export const logError = async (errorMsg, source, line, col, errorObj, requestContext = null) => {
  // ดักการส่งซ้ำ
  if (isSpamming(errorMsg)) return

  // แปลงข้อมูล payload ก่อนส่ง (แสดงข้อมูลดิบทั้งหมด ไม่เซนเซอร์)
  let safeRequestContext = null
  if (requestContext) {
    try {
      const ObjectData = typeof requestContext === 'string' ? requestContext : requestContext
      const rawStr = typeof ObjectData === 'string' ? ObjectData : JSON.stringify(ObjectData)
      if (isTooLarge(rawStr)) {
        safeRequestContext = `ข้อมูลเยอะเกินขนาด ขอลดทอนเหลือ:\n${String(rawStr).substring(0, 1000)}...`
      } else {
        safeRequestContext = rawStr
      }
    } catch (e) {
      safeRequestContext = `[ข้อมูลซับซ้อนเกินไป แปลงเป็นข้อความไม่ได้: ${e.message}]`
    }
  }

  // พยายามดึง shopId
  let shopId = null
  try {
    const sessionStr = sessionStorage.getItem('vue-session-key')
    if (sessionStr) {
      shopId = JSON.parse(sessionStr).shopId || null
    }
  } catch (e) {}

  // Fallback: ดึง shopId จาก URL Query String
  if (!shopId) {
    try {
      const urlParams = new URLSearchParams(window.location.search)
      shopId = urlParams.get('shopId') || null
    } catch (e) {}
  }

  // แปลงเวลาให้เป็นโซนเมืองไทยโดยเฉพาะ (Asia/Bangkok) แบบ YYYY-MM-DDTHH:mm:ss
  let thaiTimeStr = new Date().toISOString() // fallback
  try {
    thaiTimeStr = new Date().toLocaleString('sv-SE', { timeZone: 'Asia/Bangkok' }).replace(' ', 'T')
  } catch (e) {}

  // จัดเตรียมข้อมูลที่จะส่ง
  const errorData = {
    message: String(errorMsg || 'Unknown Error').substring(0, 1000),
    source: String(source || 'Unknown Source').substring(0, 200),
    path: window.location.pathname,
    url: window.location.href,
    userAgent: navigator.userAgent.substring(0, 300),
    timestamp: thaiTimeStr,
    stack: (errorObj && errorObj.stack) ? String(errorObj.stack).substring(0, 2000) : null,
    shopId: shopId,
    requestContext: safeRequestContext
  }

  // ตรวจสอบเช็คอินเทอร์เน็ตและสั่งบันทึกข้อมูล
  const msgLower = String(errorMsg || '').toLowerCase()
  const isNetworkError = msgLower.includes('network error') || msgLower.includes('cors')

  // หากเป็น Network Error ให้ข้ามไปเลย ไม่ต้องส่ง Discord และไม่ต้องเก็บลง Local Storage ตามคำขอ
  if (isNetworkError) return

  if (navigator.onLine) {
    // 📢 ยิงเข้า Discord เป็นการแจ้งเตือนหลัก
    const success = await sendToDiscord(errorData)
    // หากส่งไม่สำเร็จ (เช่น Discord ปิดปรับปรุง หรือ โดนบล็อค) ให้เก็บไว้ก๊อกสอง
    if (!success) saveToOfflineQueue(errorData)
  } else {
    // ถ้าไม่มีเน็ต ให้เก็บไว้ก่อน
    saveToOfflineQueue(errorData)
  }
}

// ตรวจสอบและส่งข้อมูลเมื่อเน็ตกลับมาทำงาน
export const syncOfflineErrors = async () => {
  if (!navigator.onLine) return

  let queue = []
  try { queue = JSON.parse(localStorage.getItem(ERROR_QUEUE_KEY) || '[]') } catch (e) {}

  if (queue.length === 0) return

  const remainingQueue = []
  for (const errorData of queue) {
    const msgLower = String(errorData.message || '').toLowerCase()
    const isNetworkError = msgLower.includes('network error') || msgLower.includes('cors')

    if (isNetworkError) {
      // ถ้าเป็น Network Error ตอน sync ก็ไม่ต้องส่ง Discord เหมือนกัน (แต่ถือว่าจัดการแล้ว)
      continue
    }

    const success = await sendToDiscord(errorData)
    if (!success) remainingQueue.push(errorData) // ถ้าส่งไม่ผ่านเก็บไว้ก่อน
  }

  try { localStorage.setItem(ERROR_QUEUE_KEY, JSON.stringify(remainingQueue)) } catch (e) {}
}

window.addEventListener('online', syncOfflineErrors)



// WEBPACK FOOTER //
// ./src/utils/errorLogger.js